import { Injectable } from '@angular/core';
import { SelectOptions } from '@cbuild/controls';
import { CsHttpClientService } from '@cbuild/cs-common-data-services';
import { Observable } from 'rxjs';
import { SelectOptionsWithPipeline } from './transfer-user-leads.model';

@Injectable()
export class TransferLeadsService {
  constructor(private http: CsHttpClientService) {}

  public getPipelines(): Observable<SelectOptions> {
    return this.http.read<SelectOptions>('api/common/pipelines/get');
  }

  public getLeadStages(): Observable<SelectOptionsWithPipeline> {
    return this.http.read<SelectOptionsWithPipeline>('api/common/lead/stages');
  }

  public getLeadUsers(): Observable<SelectOptionsWithPipeline> {
    return this.http.read<SelectOptionsWithPipeline>(
      'api/common/pipeline-wise/users/get'
    );
  }
}
